import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnlockStatusGlow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 670 152"
    fill="none"
    {...props}
  >
    <g clipPath="url(#unlock-status-glow-clip)">
      <g filter="url(#unlock-status-glow-blur)">
        <ellipse cx={341} cy={-13} rx={415} ry={73} fill="#FFDDE3" />
      </g>
    </g>
    <defs>
      <filter
        id="unlock-status-glow-blur"
        x={-174}
        y={-186}
        width={1030}
        height={346}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation={50}
          result="unlock-status-glow-blur-effect"
        />
      </filter>
      <clipPath id="unlock-status-glow-clip">
        <rect width={670} height={152} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUnlockStatusGlow;
